import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import ImagePlaceholder from "./img-placeholder.svg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  block-size: 100%;
  padding: 28px;

  font-family: ${fontRobotoCondensed};

  border-radius: 12px;

  background-color: #ecebe3;
`;

export const Heading = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 14px;
`;

export const ContentContainer = styled.div`
  > div + div {
    margin-block-start: 16px;
    padding-block-start: 16px;
    border-block-start: 2px solid #f7f6ef;
  }
`;

export const PlaceHolderContainer = styled.div``;

export const StyledImagePlaceholder = styled(ImagePlaceholder)`
  inline-size: 100%;
  block-size: 100%;
`;
